import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { Page } from '../components';
import { reactPlugin } from "../AppInsights";
import { ObjectsView } from '../features/ObjectsView'
import { useIntl } from 'react-intl';
import React from "react";
import { RootPageSelector } from "../components/RootPageSelector/RootPageSelector";


const Objects = () => {
    const intl = useIntl();

    return (
        <Page actionButton={<RootPageSelector/>} header={intl.formatMessage({ id: "Pages.Objects.header", defaultMessage: "Overview" })} subheader={intl.formatMessage({ id: "Pages.Objects.subheader", defaultMessage: "See all your apps here" })}>
            <ObjectsView></ObjectsView>
        </Page >
    )

}


export default React.memo(withAITracking(reactPlugin, Objects));
